const alertMixin = {
  methods: {
    successMessage(message) {
      this.$bvToast.toast(message, {
        variant: 'success',
        autoHideDelay: 5000,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    errorMessage(message) {
      this.$bvToast.toast(message, {
        variant: 'danger',
        autoHideDelay: 5000,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    warningMessage(message) {
      this.$bvToast.toast(message, {
        variant: 'info',
        autoHideDelay: 5000,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    showMsgBox(msg, title) {
      this.$bvModal.msgBoxOk(msg, {
        title: title,
        size: 'md',
        buttonSize: 'xl',
        okVariant: 'dark',
        headerClass: 'p-2 border-bottom-3',
        footerClass: 'p-2 border-top-7',
        centered: true,
        footerBorderVariant: 'dark',
        headerBorderVariant: 'dark',
        footerBgVariant: 'danger',
        bodyBgVariant: 'danger',
        headerBgVariant: 'danger',
      })
    },
  },
}

export default alertMixin;